import { useState } from "react";
import axios from "axios";

const gold = "#c8a96e";

export default function Generator() {
  const [keyword, setKeyword] = useState("");
  const [style, setStyle] = useState("brandable");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function generate() {
    if (!keyword.trim()) return;
    setLoading(true);
    setResult("");
    setError("");
    try {
      const { data } = await axios.post("/api/ai/generate", { keyword, style });
      setResult(data.result);
    } catch (err) {
      setError(err.response?.data?.error || "حدث خطأ في الاتصال");
    }
    setLoading(false);
  }

  return (
    <div>
      <p style={{ color: "#666", fontSize: 13, marginBottom: 20 }}>أدخل مجالاً أو كلمة وسأولّد لك أفكار دومينات ذكية</p>
      <input value={keyword} onChange={(e) => setKeyword(e.target.value)}
        placeholder="مثال: عقارات، طعام، تقنية، finance..."
        style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 10, padding: "13px 16px", color: "#fff", fontSize: 14, outline: "none", marginBottom: 14, fontFamily: "inherit" }} />
      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        {[["brandable", "🔤 Brandable"], ["geo", "🌍 جغرافي"], ["exact", "🎯 Exact Match"]].map(([val, lbl]) => (
          <button key={val} onClick={() => setStyle(val)}
            style={{ flex: 1, padding: "10px 4px", borderRadius: 8, border: `1px solid ${style === val ? gold : "rgba(255,255,255,0.1)"}`, background: style === val ? `${gold}18` : "transparent", color: style === val ? gold : "#555", cursor: "pointer", fontSize: 12, fontFamily: "inherit" }}>
            {lbl}
          </button>
        ))}
      </div>
      <button onClick={generate} disabled={loading}
        style={{ width: "100%", background: loading ? "#333" : gold, color: "#0f0d0a", border: "none", borderRadius: 10, padding: 14, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", fontSize: 14, fontFamily: "inherit" }}>
        {loading ? "جارٍ التوليد..." : "ولّد أفكاراً ◇"}
      </button>
      {loading && (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <div style={{ color: gold, fontSize: 32, marginBottom: 12 }}>◇</div>
          <div style={{ color: "#666", fontSize: 13 }}>جارٍ توليد الأفكار...</div>
        </div>
      )}
      {error && <div style={{ background: "rgba(196,124,124,0.1)", border: "1px solid rgba(196,124,124,0.3)", borderRadius: 10, padding: 14, color: "#c47c7c", fontSize: 13, marginTop: 16 }}>{error}</div>}
      {result && (
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,169,110,0.2)", borderRadius: 16, padding: 20, marginTop: 20 }}>
          <div style={{ color: gold, fontSize: 11, letterSpacing: 2, marginBottom: 14 }}>الأفكار المقترحة</div>
          <div style={{ color: "#ddd", fontSize: 14, lineHeight: 2, whiteSpace: "pre-wrap" }}>{result}</div>
        </div>
      )}
    </div>
  );
}
